import { SuggestionCreateDto } from '@interfaces/suggestionInterface';
import { suggestionService } from '@services/index';
import { useMutation } from '@tanstack/react-query';

export default function useMutationCreateSuggestion() {
	return useMutation({
		mutationFn: (suggestionDto: SuggestionCreateDto) => suggestionService.createSuggestion(suggestionDto)
	});
}
